import { Button, Select } from '@scuf/common';
import { useEffect, useState } from 'react';
import { consumeAPIs, IAPIPackage } from '../../commonUtils/APIContext';
import FillTemplateDetail from './FillTemplateDetail';
import { EDeviceType, EEquipmentType, IOption, ITemplateDetail } from './TemplateModel';
import i18next from 'i18next';
import './TemplateList.scss';
import useFetch, { IUseFetch } from '../../commonUtils/useFetch';
import { IOrganisationState } from '../../commonUtils/Redux/Global/globalShared';
import { useSelector } from 'react-redux';
import { LDProps } from 'launchdarkly-react-client-sdk/lib/withLDConsumer';
import { RouteProps } from 'react-router-dom';

interface ITemplateListProps extends LDProps, RouteProps, IAPIPackage {}

interface IStandardGetResponse {
  "resource": {
    "metadata": any,
    "resources": any[]
  },
  "errorMessage": string
}
const builtInTemplatePayload = {
  filters: [{
    filterType: 'match-exact',
    filterJson: '{"phrase":"Device","field":"templateType"}'
  },
  {
    filterType: 'match',
    filterJson: '{"phrase":"Meter","fields":["tags"]}'
  }]
};
export const TemplateList = (props: ITemplateListProps) => {
  const [showCreateTemplate, setShowCreateTemplate] = useState<boolean>(false);
  const [showEditTemplate, setShowEditTemplate] = useState<boolean>(false);
  const [showViewTemplate, setShowViewTemplate] = useState<boolean>(false);
  const [showTemplateType, setShowTemplateType] = useState<boolean>(true);
  const [templateId, setTemplateId] = useState<string>('');
  const [equipmentType, setEquipmentType] = useState<string>(EEquipmentType.Meter);
  const [viewTemplateData, setViewTemplateData] = useState<ITemplateDetail>();
  const [templates, setTemplates] = useState<any[]>([]);

  const userProfileDetails = useSelector(
    (state: IOrganisationState) => state.globalShared.userList
  );

  const getEquipmentType = (type: string) => {
    if (equipmentType === EEquipmentType.Meter) {
      setEquipmentType(EEquipmentType.Meter);
    } else {
      setEquipmentType('');
    }
  }

  useEffect(() => {
    if (equipmentType === EEquipmentType.Meter) {
      setShowTemplateType(false);
    } else {
      setShowTemplateType(false);
    }
  }, [equipmentType]);

  const [
    standardTempData,
    isLoadingStandardData,
    errorStandardData,
    fetchStandardTemplateData
  ]: IUseFetch<IStandardGetResponse> = useFetch(
    `${props.baseURL}/api/v1/standardtemplates/datafilters`,
    props.authFetch,
    undefined,
    true
  );

  const [
    builtInStandardTempData,
    isLoadingbuiltInStandardData,
    errorbuiltInStandardData,
    fetchbuiltInStandardTemplateData
  ]: IUseFetch<any[]> = useFetch(
    `${props.baseURL}/api/v6/templates/datafilters`,
    props.authFetch,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(builtInTemplatePayload)
    },
    true
  );

  useEffect(() => {
    fetchStandardTemplateData();
  }, []);

  useEffect(() => {
    if (userProfileDetails){
      if(userProfileDetails.email.toLocaleLowerCase().includes('honeywell.com')) {
      fetchbuiltInStandardTemplateData();
    }
  }
  }, [userProfileDetails]);

  useEffect(() => {
    let allTemplates: any[] = [];
    if (builtInStandardTempData) {
      allTemplates = [...builtInStandardTempData.map(item => { return { ...item, isBuiltInTemplate: true } })]
    }
    
    if (standardTempData) {
      if (userProfileDetails){
        if(!(userProfileDetails.email.toLocaleLowerCase().includes('honeywell.com'))) {
          allTemplates = [...allTemplates,...standardTempData.resource.resources.filter(x => x.createdBy === userProfileDetails?.id)]
         } else {
          allTemplates = [...allTemplates, ...standardTempData.resource.resources];
        }
      }
    }
    setTemplates(allTemplates);
  }, [standardTempData, builtInStandardTempData]);

  const standardDataToSelectOptions = () => {
    return templates.map((org: any) => {
      const option: IOption = { value: org.id, text: org.name + (org.isBuiltInTemplate ? ' (b)' : '') };
      return option;
    });
  };

  const onListTemplateChange = (templateId: string) => {
    setShowViewTemplate(true);
    setShowCreateTemplate(false);
    setShowEditTemplate(false);
    setTemplateId(templateId);
    const filterData = templates.find(x => x.id === templateId);

    let tempDetail: ITemplateDetail = {
      id: filterData.id,
      name: filterData.name,
      templateName: filterData.name,
      vendorName: filterData?.attributes?.vendorName,
      isBuiltInTemplate: filterData.isBuiltInTemplate,
      modelName: filterData?.templateConfiguration?.modelNames?.[0],
      templateConfiguration: {
        propertyAttributes: filterData?.templateConfiguration?.application?.properties
      }
    }
    setViewTemplateData(tempDetail);
  }

  const onCancelFillTemplateDetail = () => { setShowCreateTemplate(false); setShowEditTemplate(false); setShowViewTemplate(false); setTemplateId(''); }
  const onSaveFillTemplateDetail = (meterId: string) => { fetchStandardTemplateData(); setShowCreateTemplate(false); setShowEditTemplate(false); setTemplateId(meterId); }

  useEffect(() => {
    if (templates && templateId) {
      onListTemplateChange(templateId);
    }
  }, [templates]);
  const onCreateReset = () => { setShowCreateTemplate(true); setShowViewTemplate(false); setViewTemplateData(undefined); }

  return (
    <div className="template-list-view">
      <div className='select-template'>
        <div className='temlpate-title'>{i18next.t('templateMangement')}</div>
        <Button type='primary' disabled={showEditTemplate || showCreateTemplate || !equipmentType} onClick={() => onCreateReset()} className="createTemplate">{i18next.t('create')}</Button>
        {
          templateId && viewTemplateData && !viewTemplateData.isBuiltInTemplate &&
          (<Button type='primary' disabled={showEditTemplate} onClick={() => { setShowEditTemplate(true); setShowViewTemplate(false); }} className="createTemplate">{i18next.t('edit')}</Button>)
        }

      </div>
      <div className="template-heading">
      <Select
          className="user-list-org-selector"
          options={[{ text: EEquipmentType.Meter, value: EEquipmentType.Meter }]}
          label={i18next.t('equipmentType')}
          onChange={type => getEquipmentType(type)}
          loading={false}
          value={equipmentType}
          placeholder={i18next.t('selectType')}
        />
        {!showCreateTemplate && !showTemplateType &&
          <Select
            className="user-list-org-selector"
            options={standardDataToSelectOptions()}
            value={templateId}
            label={i18next.t('listOfTemplate')}
            onChange={templateId => onListTemplateChange(templateId)}
            loading={isLoadingStandardData || isLoadingbuiltInStandardData}
            placeholder={i18next.t('selectTemplate')}
          />
        }
        </div>
      {
        ((showCreateTemplate || showEditTemplate) || (showViewTemplate && viewTemplateData)) && (
          <FillTemplateDetail templateData={viewTemplateData} deviceType={EDeviceType.ModbusElectricMeter} isEditTemplate={showEditTemplate} isViewTemplate={showViewTemplate} onCancel={() => onCancelFillTemplateDetail()} onSave={(meterId: string) => onSaveFillTemplateDetail(meterId)} />
        )
      }
    </div>
  );
};
export default consumeAPIs(TemplateList);
